/* ----- COMPONENT TEST DATA ---- 
    1. Make sure to change "template" to your actual component name
*/
import { WideStackedTextImageBlock as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  eyebrow: 'our story',
  header: 'Of course there’s more to our story.',
  bodyText:
    'For over 40 years, we’ve built a globally renowned reputation around our original vision: to deliver each and every one of our clients tailored, unmatched real estate services that bring their dreams to life.',
  img: '/assets/textimageplaceholder.png',
  ctaText: 'Learn More',
  ctaUrl: '#',
  eyebrow2: 'Our Commitment',
  header2: 'Creating inclusive communities.',
  bodyText2:
    'Engel & Völkers is a proud champion of Special Olympics, working together to unleash the human spirit through the transformative power and joy of sports.',
  ctaText2: 'Learn More',
  ctaUrl2: '#',
  reverse: false,
  imgFocalPoint: {
    fields: {
      title: 'Sheridan Carousel Image',
      image: {
        metadata: {
          tags: [],
        },
        fields: {
          title: 'carousel-sheridan.jpg',
          file: {
            url: '/assets/textimageplaceholder.png',
            details: {
              size: 176764,
              image: {
                width: 1920,
                height: 1080,
              },
            },
            fileName: 'carousel-sheridan.jpg',
            contentType: 'image/jpeg',
          },
        },
      },
      focalPoint: {
        focalPoint: {
          x: 1037,
          y: 438,
        },
      },
    },
  },
};

export default fakeProps(schema, TestData);
